import { OrderType, ResponseRowByOrderType } from 'apiConnector/secondary-market/batch/model';
import { useUserNotification } from 'hooks/useUserNotification';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useMapMessage } from 'routes/secondary-market-batch/grid/hooks/use-map-message';

export function useShowToasterMessages(orderType: OrderType) {
  const notification = useUserNotification();
  const mapMessage = useMapMessage(orderType);
  const { formatMessage } = useIntl();
  return useCallback(
    (data: ResponseRowByOrderType[]) => {
      const messages = data.flatMap(row => {
        return [...(row.metadata.messages ?? []), ...Object.values(row.metadata.messageByColumns ?? {}).flat()];
      });
      const messagesWithToaster = messages.filter(m => m.toaster);
      messagesWithToaster.forEach(m => {
        if (m.level === 'Error' || m.level === 'Critical') {
          notification.error({
            title: formatMessage({ id: `generic.error.message` }),
            content: [mapMessage(m)],
          });
        }
      });
    },
    [mapMessage, notification, formatMessage],
  );
}
